import { syncActionFormCurrentState } from './action_form'
import { initBottomCvArea } from './ui/bottom_cv_area'
import { initExplicitSmoothAnchorLinks, initSmoothAnchorLinks } from './ui/smooth_anchor_links'

export { initBottomCvArea, initSmoothAnchorLinks }

export function syncChangedActionForm(event) {
  const input = event.target
  if (!(input instanceof Element)) return
  if (!input.matches('.js-action-form .js-form-input')) return

  syncActionFormCurrentState(input.closest('.js-action-form'))
}

export function initSharedPageInteractions({ smoothAnchorLinks = 'none' } = {}) {
  document.addEventListener('change', syncChangedActionForm)
  initBottomCvArea()

  if (smoothAnchorLinks === 'all') {
    initSmoothAnchorLinks()
  }

  if (smoothAnchorLinks === 'explicit') {
    initExplicitSmoothAnchorLinks()
  }
}
